import { render } from "./AppFooter.vue?vue&type=template&id=541b6dc6&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=541b6dc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-541b6dc6"

export default script